import {Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'gen-invalid-tooltip',
  templateUrl: './invalid-tooltip.component.html',
  styleUrls: ['./invalid-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvalidTooltipComponent implements OnInit,OnChanges {
  @Input() tooltipRequired:boolean = false;
  @Input() type:string;
  @Input() tooltipPlacement:string = 'top';
  @Input() tooltipText:string;
  @Input() tooltipShow?: boolean = true;
  @Input() invalidTooltipText: string = '';
  constructor(private detector: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngOnChanges(changes: any){
    if(changes.tooltipRequired && changes.tooltipRequired.previousValue !== changes.tooltipRequired.currentValue){
      this.detector.detectChanges();
      this.tooltipRequired = changes.tooltipRequired.currentValue;
    }
  }

  getTooltipText(){
    return this.invalidTooltipText ? this.invalidTooltipText : this.tooltipText;
  }
}
